import React, { useState } from 'react';

const Contacto: React.FC = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    mensaje: ''
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    alert(`Gracias ${formData.nombre}, tu mensaje ha sido enviado!`);
    setFormData({ nombre: '', email: '', mensaje: '' });
  };

  return (
    <div className="page">
      <div className="container">
        <div className="contact-header">
          <h3 className="section-title">Contáctanos</h3>
          <p className="section-subtitle">Estamos aquí para ayudarte</p>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <h4>Información de Contacto</h4>
            
            <div className="contact-item">
              <span className="contact-icon">📍</span>
              <div>
                <strong>Dirección:</strong>
                <p>Calle Principal #123, La Paz, Bolivia</p>
              </div>
            </div>

            <div className="contact-item">
              <span className="contact-icon">📞</span>
              <div>
                <strong>Teléfono:</strong>
                <p>+591 79397892</p>
              </div>
            </div>

            <div className="contact-item">
              <span className="contact-icon">✉️</span>
              <div>
                <strong>Email:</strong>
                <p>pizarroapaza.alisonbelen@gmail.com</p>
              </div>
            </div>

            <div className="contact-item">
              <span className="contact-icon">🕒</span>
              <div>
                <strong>Horarios:</strong>
                <p>Lunes a Viernes: 8:00 AM - 8:00 PM</p>
                <p>Sábados y Domingos: 9:00 AM - 6:00 PM</p>
              </div>
            </div>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <h4>Envíanos un Mensaje</h4>
            
            <div className="form-group">
              <label htmlFor="nombre">Nombre:</label>
              <input
                type="text"
                id="nombre"
                name="nombre"
                value={formData.nombre}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email:</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="mensaje">Mensaje:</label>
              <textarea
                id="mensaje"
                name="mensaje"
                value={formData.mensaje}
                onChange={handleChange}
                rows={5}
                required
              />
            </div>

            <button type="submit" className="submit-btn">
              Enviar Mensaje
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contacto;